import { render, staticRenderFns } from "./EnrolmentDetails.vue?vue&type=template&id=3d822696&scoped=true&"
import script from "./EnrolmentDetails.vue?vue&type=script&lang=js&"
export * from "./EnrolmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./EnrolmentDetails.vue?vue&type=style&index=0&id=3d822696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d822696",
  null
  
)

export default component.exports